import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function RedirectUrl() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/");
  });
}
